import { findTimelineGaps, convertDateRangesToMarkdown } from 'helpers/date';
import {
  INVALID_DURATION, INCOMPLETE_DURATION, MISSING_ITEMS, PRESENT_UNCHECKED
} from 'constants/errors';
import { ListModel, DateRangeModel } from 'forms/shared/types';
import { EmptyList } from 'forms/shared/models';
import { BaseCustomValidator } from '../types';

type ExpectedListItemType = {
  Dates: DateRangeModel
}

const durationCoverageBaseValidator: BaseCustomValidator<ListModel<ExpectedListItemType>> = (
  validateModel
) => (value, options, key, attributes, globalOptions) => {
  const {
    requiredDuration, additionalDates, requirePresent, requirePresentMessage
  } = options;
  if (requirePresent) {
    return requirePresentMessage || PRESENT_UNCHECKED;
  }
  if (!requiredDuration) { return INVALID_DURATION; }

  // Extract valid date ranges
  const { items } = { ...EmptyList<ExpectedListItemType>(), ...value };

  if (!items || !items.length) { return MISSING_ITEMS; }
  if (items.length === 0) { return MISSING_ITEMS; }

  let ranges: DeepSafePartial<DateRangeModel[]> = items
    .filter(
      (i) => i.Item
        && i.Item.Dates
        && validateModel(
          { Dates: i.Item.Dates },
          { Dates: { presence: true, daterange: true } },
          { ...globalOptions, ...options }
        ) === true
    )
    .map((i) => i.Item.Dates);

  if (additionalDates) {
    additionalDates.forEach((element) => {
      ranges = ranges.concat(element);
    });
  }

  const timelineGaps = findTimelineGaps(requiredDuration, ranges);
  let incompleteDuration = options.incompleteDuration;
  if (timelineGaps.length > 0 && options?.incompleteDuration?.localeOptions?.messageParameters) {
    // might be worth adding lodash as alternative to multiple spreads to avoid mutation
    incompleteDuration = {
      ...options.incompleteDuration,
      localeOptions: {
        ...options.incompleteDuration.localeOptions,
        messageParameters: {
          ...options.incompleteDuration.localeOptions.messageParameters,
          gaps: convertDateRangesToMarkdown(
            timelineGaps
          )
        },
      },
    };
    return incompleteDuration ?? INCOMPLETE_DURATION;
  }

  return null;
};

export default durationCoverageBaseValidator;
